/**
 * Slug-zoekwoord voor journal-artikelen. De slug is de zoekopdracht waarop het
 * artikel gevonden moet worden ("taxi tijdens de spits"), dus dat woordcombinatie
 * hoort in de title, in een kop en in de meta description terug te komen.
 */
export function slugKeyword(slug: string): string {
  return slug.replace(/-/g, " ").trim();
}

/** Zoekwoord met een hoofdletter, geschikt als kop of als start van een zin. */
export function sentenceCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function coverage(text: string, keyword: string): number {
  const words = keyword.toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return 1;
  const t = text.toLowerCase();
  return words.filter((w) => t.includes(w)).length / words.length;
}

/** Zorgt dat het zoekwoord voldoende in de description voorkomt. */
export function withKeywordDescription(description: string, keyword: string): string {
  if (coverage(description, keyword) >= 0.9) return description;
  const prefix = `${sentenceCase(keyword)}: `;
  const combined = `${prefix}${description.charAt(0).toLowerCase()}${description.slice(1)}`;
  if (combined.length <= 158) return combined;
  const cut = combined.slice(0, 155);
  const lastStop = cut.lastIndexOf(". ");
  if (lastStop > 60) return cut.slice(0, lastStop + 1).trim();
  const words = cut.split(" ");
  words.pop();
  return `${words.join(" ").replace(/[\s,;:-]+$/, "")}.`;
}

/** Zorgt dat het zoekwoord in de title staat, zonder de 62 tekens te overschrijden. */
export function withKeywordTitle(title: string, _keyword: string, suffix = " | Taxiritje.nl"): string {
  // De echte artikeltitel blijft altijd staan; nooit vervangen door slugtekst.
  const base = title;
  const withSuffix = base.endsWith("Taxiritje.nl") ? base : `${base}${suffix}`;
  if (withSuffix.length <= 62) return withSuffix;
  return base.length <= 62 ? base : `${base.slice(0, 59).trimEnd()}...`;
}

/** Zorgt dat het zoekwoord ook in de H1 van een artikel staat. */
export function withKeywordHeading(title: string, _keyword: string): string {
  // De redactionele kop blijft ongewijzigd; slugwoorden in de H1 lezen onnatuurlijk.
  return title;
}
